/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Umbraco Delivery API
 * You can find out more about the Umbraco Delivery API in [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api).
 * OpenAPI spec version: Latest
 */

import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type { ErrorType } from "../../../../../_packages/umbrella/lib/orval/custom-instance.ts";

import { customInstance } from "../../../../../_packages/umbrella/lib/orval/custom-instance.ts";
import type {
	ApiExtendedContentResponse,
	GetContent20Params,
	GetContentItemById20Params,
	GetContentItemByPath20Params,
	GetContentItems20Params,
	GetUmbracoDeliveryApiV2ContentExtendedItemPathParams,
	HttpValidationProblemDetails,
	IApiContentResponseModel,
	PagedIApiContentResponseModel,
	ProblemDetails,
} from "../../models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
	query: T,
	queryKey: K,
): T & { queryKey: K } => {
	const result = { queryKey } as T & { queryKey: K };
	for (const key of Object.keys(query)) {
		// The explicit queryKey always wins, matching the previous
		// `{ ...query, queryKey }` spread where it was set last.
		if (key === "queryKey") continue;
		Object.defineProperty(result, key, {
			enumerable: true,
			configurable: true,
			get: () => (query as Record<string, unknown>)[key],
		});
	}
	return result;
};

export const getContent20 = (
	params?: GetContent20Params,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<PagedIApiContentResponseModel>(
		{ url: `/umbraco/delivery/api/v2/content`, method: "GET", params, signal },
		options,
	);
};

export const getGetContent20QueryKey = (params?: GetContent20Params) => {
	return [
		`/umbraco/delivery/api/v2/content`,
		...(params ? [params] : []),
	] as const;
};

export const getGetContent20QueryOptions = <
	TData = Awaited<ReturnType<typeof getContent20>>,
	TError = ErrorType<ProblemDetails | HttpValidationProblemDetails | void>,
>(
	params?: GetContent20Params,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getContent20>>, TError, TData>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetContent20QueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getContent20>>> = ({
		signal,
	}) => getContent20(params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getContent20>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetContent20QueryResult = NonNullable<
	Awaited<ReturnType<typeof getContent20>>
>;
export type GetContent20QueryError = ErrorType<
	ProblemDetails | HttpValidationProblemDetails | void
>;

export function useGetContent20<
	TData = Awaited<ReturnType<typeof getContent20>>,
	TError = ErrorType<ProblemDetails | HttpValidationProblemDetails | void>,
>(
	params: undefined | GetContent20Params,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getContent20>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getContent20>>,
					TError,
					Awaited<ReturnType<typeof getContent20>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContent20<
	TData = Awaited<ReturnType<typeof getContent20>>,
	TError = ErrorType<ProblemDetails | HttpValidationProblemDetails | void>,
>(
	params?: GetContent20Params,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getContent20>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getContent20>>,
					TError,
					Awaited<ReturnType<typeof getContent20>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContent20<
	TData = Awaited<ReturnType<typeof getContent20>>,
	TError = ErrorType<ProblemDetails | HttpValidationProblemDetails | void>,
>(
	params?: GetContent20Params,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getContent20>>, TError, TData>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetContent20<
	TData = Awaited<ReturnType<typeof getContent20>>,
	TError = ErrorType<ProblemDetails | HttpValidationProblemDetails | void>,
>(
	params?: GetContent20Params,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getContent20>>, TError, TData>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetContent20QueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

export const getGetContent20SuspenseQueryOptions = <
	TData = Awaited<ReturnType<typeof getContent20>>,
	TError = ErrorType<ProblemDetails | HttpValidationProblemDetails | void>,
>(
	params?: GetContent20Params,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getContent20>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetContent20QueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getContent20>>> = ({
		signal,
	}) => getContent20(params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
		Awaited<ReturnType<typeof getContent20>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetContent20SuspenseQueryResult = NonNullable<
	Awaited<ReturnType<typeof getContent20>>
>;
export type GetContent20SuspenseQueryError = ErrorType<
	ProblemDetails | HttpValidationProblemDetails | void
>;

export function useGetContent20Suspense<
	TData = Awaited<ReturnType<typeof getContent20>>,
	TError = ErrorType<ProblemDetails | HttpValidationProblemDetails | void>,
>(
	params: undefined | GetContent20Params,
	options: {
		query: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getContent20>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContent20Suspense<
	TData = Awaited<ReturnType<typeof getContent20>>,
	TError = ErrorType<ProblemDetails | HttpValidationProblemDetails | void>,
>(
	params?: GetContent20Params,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getContent20>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContent20Suspense<
	TData = Awaited<ReturnType<typeof getContent20>>,
	TError = ErrorType<ProblemDetails | HttpValidationProblemDetails | void>,
>(
	params?: GetContent20Params,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getContent20>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetContent20Suspense<
	TData = Awaited<ReturnType<typeof getContent20>>,
	TError = ErrorType<ProblemDetails | HttpValidationProblemDetails | void>,
>(
	params?: GetContent20Params,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getContent20>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetContent20SuspenseQueryOptions(params, options);

	const query = useSuspenseQuery(
		queryOptions,
		queryClient,
	) as UseSuspenseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return withQueryKey(query, queryOptions.queryKey);
}

export const getUmbracoDeliveryApiV2ContentExtendedItemPath = (
	params?: GetUmbracoDeliveryApiV2ContentExtendedItemPathParams,
	path: string = "",
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<ApiExtendedContentResponse>(
		{
			url: `/umbraco/delivery/api/v2/content/extended-item/${path}`,
			method: "GET",
			params,
			signal,
		},
		options,
	);
};

export const getGetUmbracoDeliveryApiV2ContentExtendedItemPathQueryKey = (
	params?: GetUmbracoDeliveryApiV2ContentExtendedItemPathParams,
	path: string = "",
) => {
	return [
		`/umbraco/delivery/api/v2/content/extended-item/${path}`,
		...(params ? [params] : []),
	] as const;
};

export const getGetUmbracoDeliveryApiV2ContentExtendedItemPathQueryOptions = <
	TData = Awaited<
		ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>
	>,
	TError = ErrorType<void>,
>(
	params?: GetUmbracoDeliveryApiV2ContentExtendedItemPathParams,
	path: string = "",
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetUmbracoDeliveryApiV2ContentExtendedItemPathQueryKey(params, path);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>>
	> = ({ signal }) =>
		getUmbracoDeliveryApiV2ContentExtendedItemPath(
			params,
			path,
			requestOptions,
			signal,
		);

	return {
		queryKey,
		queryFn,
		enabled: path !== null && path !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUmbracoDeliveryApiV2ContentExtendedItemPathQueryResult =
	NonNullable<
		Awaited<ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>>
	>;
export type GetUmbracoDeliveryApiV2ContentExtendedItemPathQueryError =
	ErrorType<void>;

export function useGetUmbracoDeliveryApiV2ContentExtendedItemPath<
	TData = Awaited<
		ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>
	>,
	TError = ErrorType<void>,
>(
	params: undefined | GetUmbracoDeliveryApiV2ContentExtendedItemPathParams,
	path: undefined | string,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>
				>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<
						ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>
					>,
					TError,
					Awaited<
						ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>
					>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoDeliveryApiV2ContentExtendedItemPath<
	TData = Awaited<
		ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>
	>,
	TError = ErrorType<void>,
>(
	params?: GetUmbracoDeliveryApiV2ContentExtendedItemPathParams,
	path?: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>
				>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<
						ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>
					>,
					TError,
					Awaited<
						ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>
					>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoDeliveryApiV2ContentExtendedItemPath<
	TData = Awaited<
		ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>
	>,
	TError = ErrorType<void>,
>(
	params?: GetUmbracoDeliveryApiV2ContentExtendedItemPathParams,
	path?: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUmbracoDeliveryApiV2ContentExtendedItemPath<
	TData = Awaited<
		ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>
	>,
	TError = ErrorType<void>,
>(
	params?: GetUmbracoDeliveryApiV2ContentExtendedItemPathParams,
	path: string = "",
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions =
		getGetUmbracoDeliveryApiV2ContentExtendedItemPathQueryOptions(
			params,
			path,
			options,
		);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUmbracoDeliveryApiV2ContentExtendedItemPathSuspenseQueryOptions =
	<
		TData = Awaited<
			ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>
		>,
		TError = ErrorType<void>,
	>(
		params?: GetUmbracoDeliveryApiV2ContentExtendedItemPathParams,
		path: string = "",
		options?: {
			query?: Partial<
				UseSuspenseQueryOptions<
					Awaited<
						ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>
					>,
					TError,
					TData
				>
			>;
			request?: SecondParameter<typeof customInstance>;
		},
	) => {
		const { query: queryOptions, request: requestOptions } = options ?? {};

		const queryKey =
			queryOptions?.queryKey ??
			getGetUmbracoDeliveryApiV2ContentExtendedItemPathQueryKey(params, path);

		const queryFn: QueryFunction<
			Awaited<ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>>
		> = ({ signal }) =>
			getUmbracoDeliveryApiV2ContentExtendedItemPath(
				params,
				path,
				requestOptions,
				signal,
			);

		return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
			Awaited<
				ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>
			>,
			TError,
			TData
		> & { queryKey: DataTag<QueryKey, TData, TError> };
	};

export type GetUmbracoDeliveryApiV2ContentExtendedItemPathSuspenseQueryResult =
	NonNullable<
		Awaited<ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>>
	>;
export type GetUmbracoDeliveryApiV2ContentExtendedItemPathSuspenseQueryError =
	ErrorType<void>;

export function useGetUmbracoDeliveryApiV2ContentExtendedItemPathSuspense<
	TData = Awaited<
		ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>
	>,
	TError = ErrorType<void>,
>(
	params: undefined | GetUmbracoDeliveryApiV2ContentExtendedItemPathParams,
	path: undefined | string,
	options: {
		query: Partial<
			UseSuspenseQueryOptions<
				Awaited<
					ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoDeliveryApiV2ContentExtendedItemPathSuspense<
	TData = Awaited<
		ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>
	>,
	TError = ErrorType<void>,
>(
	params?: GetUmbracoDeliveryApiV2ContentExtendedItemPathParams,
	path?: string,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<
					ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoDeliveryApiV2ContentExtendedItemPathSuspense<
	TData = Awaited<
		ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>
	>,
	TError = ErrorType<void>,
>(
	params?: GetUmbracoDeliveryApiV2ContentExtendedItemPathParams,
	path?: string,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<
					ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUmbracoDeliveryApiV2ContentExtendedItemPathSuspense<
	TData = Awaited<
		ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>
	>,
	TError = ErrorType<void>,
>(
	params?: GetUmbracoDeliveryApiV2ContentExtendedItemPathParams,
	path: string = "",
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<
					ReturnType<typeof getUmbracoDeliveryApiV2ContentExtendedItemPath>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions =
		getGetUmbracoDeliveryApiV2ContentExtendedItemPathSuspenseQueryOptions(
			params,
			path,
			options,
		);

	const query = useSuspenseQuery(
		queryOptions,
		queryClient,
	) as UseSuspenseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return withQueryKey(query, queryOptions.queryKey);
}

export const getContentItemByPath20 = (
	params?: GetContentItemByPath20Params,
	path: string = "",
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<IApiContentResponseModel>(
		{
			url: `/umbraco/delivery/api/v2/content/item/${path}`,
			method: "GET",
			params,
			signal,
		},
		options,
	);
};

export const getGetContentItemByPath20QueryKey = (
	params?: GetContentItemByPath20Params,
	path: string = "",
) => {
	return [
		`/umbraco/delivery/api/v2/content/item/${path}`,
		...(params ? [params] : []),
	] as const;
};

export const getGetContentItemByPath20QueryOptions = <
	TData = Awaited<ReturnType<typeof getContentItemByPath20>>,
	TError = ErrorType<void>,
>(
	params?: GetContentItemByPath20Params,
	path: string = "",
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getContentItemByPath20>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetContentItemByPath20QueryKey(params, path);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getContentItemByPath20>>
	> = ({ signal }) =>
		getContentItemByPath20(params, path, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: path !== null && path !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getContentItemByPath20>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetContentItemByPath20QueryResult = NonNullable<
	Awaited<ReturnType<typeof getContentItemByPath20>>
>;
export type GetContentItemByPath20QueryError = ErrorType<void>;

export function useGetContentItemByPath20<
	TData = Awaited<ReturnType<typeof getContentItemByPath20>>,
	TError = ErrorType<void>,
>(
	params: undefined | GetContentItemByPath20Params,
	path: undefined | string,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getContentItemByPath20>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getContentItemByPath20>>,
					TError,
					Awaited<ReturnType<typeof getContentItemByPath20>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContentItemByPath20<
	TData = Awaited<ReturnType<typeof getContentItemByPath20>>,
	TError = ErrorType<void>,
>(
	params?: GetContentItemByPath20Params,
	path?: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getContentItemByPath20>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getContentItemByPath20>>,
					TError,
					Awaited<ReturnType<typeof getContentItemByPath20>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContentItemByPath20<
	TData = Awaited<ReturnType<typeof getContentItemByPath20>>,
	TError = ErrorType<void>,
>(
	params?: GetContentItemByPath20Params,
	path?: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getContentItemByPath20>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetContentItemByPath20<
	TData = Awaited<ReturnType<typeof getContentItemByPath20>>,
	TError = ErrorType<void>,
>(
	params?: GetContentItemByPath20Params,
	path: string = "",
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getContentItemByPath20>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetContentItemByPath20QueryOptions(
		params,
		path,
		options,
	);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

export const getGetContentItemByPath20SuspenseQueryOptions = <
	TData = Awaited<ReturnType<typeof getContentItemByPath20>>,
	TError = ErrorType<void>,
>(
	params?: GetContentItemByPath20Params,
	path: string = "",
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getContentItemByPath20>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetContentItemByPath20QueryKey(params, path);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getContentItemByPath20>>
	> = ({ signal }) =>
		getContentItemByPath20(params, path, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
		Awaited<ReturnType<typeof getContentItemByPath20>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetContentItemByPath20SuspenseQueryResult = NonNullable<
	Awaited<ReturnType<typeof getContentItemByPath20>>
>;
export type GetContentItemByPath20SuspenseQueryError = ErrorType<void>;

export function useGetContentItemByPath20Suspense<
	TData = Awaited<ReturnType<typeof getContentItemByPath20>>,
	TError = ErrorType<void>,
>(
	params: undefined | GetContentItemByPath20Params,
	path: undefined | string,
	options: {
		query: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getContentItemByPath20>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContentItemByPath20Suspense<
	TData = Awaited<ReturnType<typeof getContentItemByPath20>>,
	TError = ErrorType<void>,
>(
	params?: GetContentItemByPath20Params,
	path?: string,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getContentItemByPath20>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContentItemByPath20Suspense<
	TData = Awaited<ReturnType<typeof getContentItemByPath20>>,
	TError = ErrorType<void>,
>(
	params?: GetContentItemByPath20Params,
	path?: string,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getContentItemByPath20>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetContentItemByPath20Suspense<
	TData = Awaited<ReturnType<typeof getContentItemByPath20>>,
	TError = ErrorType<void>,
>(
	params?: GetContentItemByPath20Params,
	path: string = "",
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getContentItemByPath20>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetContentItemByPath20SuspenseQueryOptions(
		params,
		path,
		options,
	);

	const query = useSuspenseQuery(
		queryOptions,
		queryClient,
	) as UseSuspenseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return withQueryKey(query, queryOptions.queryKey);
}

export const getContentItemById20 = (
	id: string,
	params?: GetContentItemById20Params,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<IApiContentResponseModel>(
		{
			url: `/umbraco/delivery/api/v2/content/item/${id}`,
			method: "GET",
			params,
			signal,
		},
		options,
	);
};

export const getGetContentItemById20QueryKey = (
	id: string,
	params?: GetContentItemById20Params,
) => {
	return [
		`/umbraco/delivery/api/v2/content/item/${id}`,
		...(params ? [params] : []),
	] as const;
};

export const getGetContentItemById20QueryOptions = <
	TData = Awaited<ReturnType<typeof getContentItemById20>>,
	TError = ErrorType<void>,
>(
	id: string,
	params?: GetContentItemById20Params,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getContentItemById20>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetContentItemById20QueryKey(id, params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getContentItemById20>>
	> = ({ signal }) => getContentItemById20(id, params, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: id !== null && id !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getContentItemById20>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetContentItemById20QueryResult = NonNullable<
	Awaited<ReturnType<typeof getContentItemById20>>
>;
export type GetContentItemById20QueryError = ErrorType<void>;

export function useGetContentItemById20<
	TData = Awaited<ReturnType<typeof getContentItemById20>>,
	TError = ErrorType<void>,
>(
	id: string,
	params: undefined | GetContentItemById20Params,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getContentItemById20>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getContentItemById20>>,
					TError,
					Awaited<ReturnType<typeof getContentItemById20>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContentItemById20<
	TData = Awaited<ReturnType<typeof getContentItemById20>>,
	TError = ErrorType<void>,
>(
	id: string,
	params?: GetContentItemById20Params,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getContentItemById20>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getContentItemById20>>,
					TError,
					Awaited<ReturnType<typeof getContentItemById20>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContentItemById20<
	TData = Awaited<ReturnType<typeof getContentItemById20>>,
	TError = ErrorType<void>,
>(
	id: string,
	params?: GetContentItemById20Params,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getContentItemById20>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetContentItemById20<
	TData = Awaited<ReturnType<typeof getContentItemById20>>,
	TError = ErrorType<void>,
>(
	id: string,
	params?: GetContentItemById20Params,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getContentItemById20>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetContentItemById20QueryOptions(id, params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

export const getGetContentItemById20SuspenseQueryOptions = <
	TData = Awaited<ReturnType<typeof getContentItemById20>>,
	TError = ErrorType<void>,
>(
	id: string,
	params?: GetContentItemById20Params,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getContentItemById20>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetContentItemById20QueryKey(id, params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getContentItemById20>>
	> = ({ signal }) => getContentItemById20(id, params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
		Awaited<ReturnType<typeof getContentItemById20>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetContentItemById20SuspenseQueryResult = NonNullable<
	Awaited<ReturnType<typeof getContentItemById20>>
>;
export type GetContentItemById20SuspenseQueryError = ErrorType<void>;

export function useGetContentItemById20Suspense<
	TData = Awaited<ReturnType<typeof getContentItemById20>>,
	TError = ErrorType<void>,
>(
	id: string,
	params: undefined | GetContentItemById20Params,
	options: {
		query: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getContentItemById20>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContentItemById20Suspense<
	TData = Awaited<ReturnType<typeof getContentItemById20>>,
	TError = ErrorType<void>,
>(
	id: string,
	params?: GetContentItemById20Params,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getContentItemById20>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContentItemById20Suspense<
	TData = Awaited<ReturnType<typeof getContentItemById20>>,
	TError = ErrorType<void>,
>(
	id: string,
	params?: GetContentItemById20Params,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getContentItemById20>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetContentItemById20Suspense<
	TData = Awaited<ReturnType<typeof getContentItemById20>>,
	TError = ErrorType<void>,
>(
	id: string,
	params?: GetContentItemById20Params,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getContentItemById20>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetContentItemById20SuspenseQueryOptions(
		id,
		params,
		options,
	);

	const query = useSuspenseQuery(
		queryOptions,
		queryClient,
	) as UseSuspenseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return withQueryKey(query, queryOptions.queryKey);
}

export const getContentItems20 = (
	params?: GetContentItems20Params,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<IApiContentResponseModel[]>(
		{
			url: `/umbraco/delivery/api/v2/content/items`,
			method: "GET",
			params,
			signal,
		},
		options,
	);
};

export const getGetContentItems20QueryKey = (
	params?: GetContentItems20Params,
) => {
	return [
		`/umbraco/delivery/api/v2/content/items`,
		...(params ? [params] : []),
	] as const;
};

export const getGetContentItems20QueryOptions = <
	TData = Awaited<ReturnType<typeof getContentItems20>>,
	TError = ErrorType<void>,
>(
	params?: GetContentItems20Params,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getContentItems20>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetContentItems20QueryKey(params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getContentItems20>>
	> = ({ signal }) => getContentItems20(params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getContentItems20>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetContentItems20QueryResult = NonNullable<
	Awaited<ReturnType<typeof getContentItems20>>
>;
export type GetContentItems20QueryError = ErrorType<void>;

export function useGetContentItems20<
	TData = Awaited<ReturnType<typeof getContentItems20>>,
	TError = ErrorType<void>,
>(
	params: undefined | GetContentItems20Params,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getContentItems20>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getContentItems20>>,
					TError,
					Awaited<ReturnType<typeof getContentItems20>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContentItems20<
	TData = Awaited<ReturnType<typeof getContentItems20>>,
	TError = ErrorType<void>,
>(
	params?: GetContentItems20Params,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getContentItems20>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getContentItems20>>,
					TError,
					Awaited<ReturnType<typeof getContentItems20>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContentItems20<
	TData = Awaited<ReturnType<typeof getContentItems20>>,
	TError = ErrorType<void>,
>(
	params?: GetContentItems20Params,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getContentItems20>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetContentItems20<
	TData = Awaited<ReturnType<typeof getContentItems20>>,
	TError = ErrorType<void>,
>(
	params?: GetContentItems20Params,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getContentItems20>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetContentItems20QueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

export const getGetContentItems20SuspenseQueryOptions = <
	TData = Awaited<ReturnType<typeof getContentItems20>>,
	TError = ErrorType<void>,
>(
	params?: GetContentItems20Params,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getContentItems20>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetContentItems20QueryKey(params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getContentItems20>>
	> = ({ signal }) => getContentItems20(params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
		Awaited<ReturnType<typeof getContentItems20>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetContentItems20SuspenseQueryResult = NonNullable<
	Awaited<ReturnType<typeof getContentItems20>>
>;
export type GetContentItems20SuspenseQueryError = ErrorType<void>;

export function useGetContentItems20Suspense<
	TData = Awaited<ReturnType<typeof getContentItems20>>,
	TError = ErrorType<void>,
>(
	params: undefined | GetContentItems20Params,
	options: {
		query: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getContentItems20>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContentItems20Suspense<
	TData = Awaited<ReturnType<typeof getContentItems20>>,
	TError = ErrorType<void>,
>(
	params?: GetContentItems20Params,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getContentItems20>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContentItems20Suspense<
	TData = Awaited<ReturnType<typeof getContentItems20>>,
	TError = ErrorType<void>,
>(
	params?: GetContentItems20Params,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getContentItems20>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetContentItems20Suspense<
	TData = Awaited<ReturnType<typeof getContentItems20>>,
	TError = ErrorType<void>,
>(
	params?: GetContentItems20Params,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getContentItems20>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetContentItems20SuspenseQueryOptions(
		params,
		options,
	);

	const query = useSuspenseQuery(
		queryOptions,
		queryClient,
	) as UseSuspenseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return withQueryKey(query, queryOptions.queryKey);
}
